;(function ($) {


    // Accordion
    $('.js-accordion .js-item').each(function () {
        var trigger = $(this).find('.js-trigger'),
            jsHide = $(this).find('.js-content'),
            open = 'is-open',
            hash = location.hash,
            headerHeight = $('.header').outerHeight()

        $(this).find(jsHide).hide(0)

        $(trigger).click(function () {
            var jsItem = $(this).closest('.js-item')
            jsItem.toggleClass(open)
            jsHide.slideToggle(300)

            if (jsItem.find('.js-post-slider').length > 0) {
                jsItem.find('.js-post-slider').slick('resize')
            }
        })

        $(hash).each(function () {
            $(this).addClass('is-open')
            $(this).find('.js-content').slideDown(300)

            $('html, body').stop().animate({
                'scrollTop': $(this).offset().top - headerHeight - 20
            }, 1000)
        })
    })


})(jQuery);
